import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ProgressDots from './ProgressDots';
import { INTENT_OPTIONS, AUDIENCE_OPTIONS, ONBOARDING_EVENTS } from '@/constants/onboardingConfig';

export default function Screen2Intent({
  onNext,
  onBack,
  intent,
  audience,
  onIntentChange,
  onAudienceChange,
  trackEvent,
}) {
  const hasSelection = intent || audience;

  const handleIntent = (id) => {
    onIntentChange(id === intent ? null : id);
    if (id !== intent) trackEvent(ONBOARDING_EVENTS.INTENT_SELECTED, { intent: id });
  };

  const handleAudience = (id) => {
    onAudienceChange(id === audience ? null : id);
    if (id !== audience) trackEvent(ONBOARDING_EVENTS.AUDIENCE_SELECTED, { audience: id });
  };

  return (
    <div className="story-page flex flex-col fade-in">
      <div className="flex-1 overflow-y-auto px-6 pt-6 pb-4 max-w-md mx-auto w-full">
        <div className="flex items-center mb-6">
          <button
            onClick={onBack}
            className="p-2 -ml-2 text-[#8C847A] dark:text-[#7C746A] hover:text-[#2A2420] dark:hover:text-[#F0EBE4] transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
        </div>

        <ProgressDots current={1} />

        <h2 className="story-title text-2xl sm:text-3xl mb-2">
          What brings you here?
        </h2>
        <p className="story-meta mb-6">
          Both optional — just helps us personalize your experience.
        </p>

        {/* Intent */}
        <div className="mb-8">
          <p className="story-label mb-3">
            What are you creating?
          </p>
          <div className="flex flex-wrap gap-2">
            {INTENT_OPTIONS.map((opt) => (
              <button
                key={opt.id}
                onClick={() => handleIntent(opt.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium border transition-all duration-200 ${
                  intent === opt.id
                    ? 'bg-[var(--story-primary)] text-white border-[var(--story-primary)]'
                    : 'bg-transparent text-[var(--story-ink-soft)] border-[var(--story-line-strong)] hover:border-[var(--story-primary)]'
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {/* Audience */}
        <div className="mb-8">
          <p className="story-label mb-3">
            Who is this for?
          </p>
          <div className="flex flex-wrap gap-2">
            {AUDIENCE_OPTIONS.map((opt) => (
              <button
                key={opt.id}
                onClick={() => handleAudience(opt.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium border transition-all duration-200 ${
                  audience === opt.id
                    ? 'bg-[var(--story-primary)] text-white border-[var(--story-primary)]'
                    : 'bg-transparent text-[var(--story-ink-soft)] border-[var(--story-line-strong)] hover:border-[var(--story-primary)]'
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Sticky CTA */}
      <div className="shrink-0 px-6 pb-6 pt-3 max-w-md mx-auto w-full">
        <Button
          onClick={onNext}
          className="story-button-primary w-full"
        >
          {hasSelection ? 'Continue' : 'Skip for now'}
        </Button>
      </div>
    </div>
  );
}
